import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLoginCheck } from '../Middleware/Auth';

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => (
            isLoginCheck() && restricted ?
                <Redirect to="/" />
            : <Component {...props} />
        )} />
    );
};



export default PublicRoute;


// WEBPACK FOOTER //
// ./src/Route/PublicRoute.js